module.exports = __webpack_public_path__ + "img/pre-banner-bottom.991aac5f.svg";